export const ROUTES = {
  root: "/",
  verify: "/verify",
  admin: "/admin",
  adminLogin: "/admin/login",
  adminDashboard: "/admin/dashboard",
  adminNotApplication: "/admin/not-application",
  adminAllApplication: "/admin/all-application",
  adminRejectApplication: "/admin/reject-application",
  adminVillageApplication: "/admin/village-application/:mdVillageId",
} as const;
